// Article page accordion functionality
let accordions = document.querySelectorAll('.article .accordion');
if (accordions) {
    [].forEach.call(accordions, function (accordion) {
        let accordionHeader = accordion.querySelector('.accordion-header');
        if (accordionHeader) {
            accordionHeader.addEventListener('click', function () {
                accordion.classList.toggle('accordionIsOpen');
            });
        }
    });
}

// Toolbar - remove fixed positioning when toolbar reaches contributor section OR footer when no contributor section
let toolbar = document.querySelector('.article .toolbar');
let contributorSection = document.querySelector('.article-details-container');
let footer = document.querySelector('.footer');

function toolbarScroll() {
    let toolbarBottom = toolbar.getBoundingClientRect().bottom;
    let toolbarTop = toolbar.getBoundingClientRect().top;
    let headerBottom = document.querySelector('header').getBoundingClientRect().bottom;
    if (contributorSection) {
        let contributorSectionTop = contributorSection.getBoundingClientRect().top;
        if ((toolbarBottom + 40) >= contributorSectionTop) {
            toolbar.style.position = 'absolute';
            toolbar.style.bottom = 40 + 'px';
        }
    } else {
        let footerTop = footer.getBoundingClientRect().top;
        if ((toolbarBottom + 40) >= footerTop) {
            toolbar.style.position = 'absolute';
            toolbar.style.bottom = 40 + 'px';
        }
    }
    if ((toolbarTop - 40) > headerBottom) {
        toolbar.style.position = 'fixed';
        toolbar.style.bottom = '';
    }
}

function setToolbarPositioning() {
    if (toolbar) {
        if (window.innerWidth > 1000) { // Desktop. navChangesAt 1000
            window.addEventListener('scroll', toolbarScroll);
        } else { // Mobile
            window.removeEventListener('scroll', toolbarScroll);
            toolbar.style.position = 'fixed';
            toolbar.style.bottom = '';
        }
    }
}
setToolbarPositioning();


// Toolbar - language option functionality (toggle different languages)
let languageButton = document.querySelector('.toolbar-language');
if (languageButton) {
    languageButton.addEventListener('click', function () {
        languageButton.classList.toggle('showLanguageOptions');
    });
}


// Toolbar - email functionality
let emailButton = document.querySelector('.toolbar-email');
if (emailButton) {
    let emailSubject = emailButton.getAttribute('data-subject');
    let shareHref;
    if (emailSubject) {
        shareHref = `mailto:?subject=${emailSubject}&body=${window.location.href}`;
    } else {
        shareHref = `mailto:?body=${window.location.href}`;
    }
    emailButton.addEventListener('click', function (e) {
        window.location = shareHref;
        e.stopPropagation();
    });
}


// Toolbar - print functionality
let printButton = document.querySelector('.toolbar-print');
if (printButton) {
    printButton.addEventListener('click', function () {
        window.print();
    });
}

// Social JS
function popupwindow(url, w, h) {
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    return window.open(url, 'pop', 'scrollbars=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
}

let allSocial = document.querySelectorAll('.social-share');
if (allSocial) {
    [].forEach.call(allSocial, function (social) {
        let url = social.getAttribute('data-popupUrl');
        social.addEventListener('click', function () {
            popupwindow(url, 600, 400);
        });
    });
}

// Resize event handler and function calls
window.addEventListener('resize', function () {
    window.requestAnimationFrame(setToolbarPositioning);
});

//commented out til client confirms new window/new tab 

//let allGlobalAds = document.querySelectorAll('.global-ad-open');
//if (allGlobalAds) {
//    [].forEach.call(allGlobalAds, function(ad){
//        let url = ad.getAttribute('href');
//        ad.addEventListener('click', function () {
//            window.open(url, '_blank', 'toolbar=0,location=1,menubar=1');
//        })
//    })
//}